import React from "react";
import { Aurora, Card, PageHeader, Logo } from "./Shell";

export default function Blocked({ onRestart }) {
  return (
    <Aurora>
      <div className="relative max-w-3xl mx-auto px-6 sm:px-10 py-10">
        <div className="flex items-center justify-between mb-16">
          <Logo size="md" />
          <div className="font-mono text-[10px] tracking-[0.28em] uppercase text-[color:var(--danger)]">
            Pause · Care Recommended
          </div>
        </div>

        <PageHeader
          eyebrow="Safety First"
          animate={false}
          title={
            <>
              Let's pause the session<br />
              <span className="text-cyan-glow">and connect you with care.</span>
            </>
          }
          subtitle="Based on your screener responses, this tool isn't the right next step right now. You deserve direct, human support — and it is available."
        />

        <Card
          strong
          className="border-l-4"
          style={{ borderLeftColor: "var(--danger)" }}
          data-testid="blocked-resources"
        >
          <div className="font-mono text-[10px] tracking-[0.28em] uppercase text-[color:var(--danger)] mb-4">
            Immediate Support
          </div>
          <div className="space-y-4">
            <Resource
              label="988 Suicide & Crisis Lifeline (US)"
              value="Call or text 988"
            />
            <Resource label="Crisis Text Line" value="Text HOME to 741741" />
            <Resource
              label="International"
              value="findahelpline.com"
            />
            <Resource
              label="If in immediate danger"
              value="Call 911 / local emergency"
            />
          </div>
        </Card>

        <div className="mt-8 text-[color:var(--text-secondary)] leading-relaxed">
          A grounding suggestion while you decide what's next: place both feet flat on the floor, take three slow breaths with longer exhales, and look around the room — name three things you can see.
        </div>

        <div className="mt-10 flex items-center gap-4">
          <button
            type="button"
            className="btn-ghost"
            onClick={onRestart}
            data-testid="blocked-restart-btn"
          >
            ↩ Back to start
          </button>
        </div>
      </div>
    </Aurora>
  );
}

function Resource({ label, value }) {
  return (
    <div className="flex items-baseline justify-between gap-4 py-2 border-b border-[color:var(--hairline)] last:border-0">
      <div className="text-[color:var(--text-secondary)] text-sm">{label}</div>
      <div className="font-mono text-cyan-glow text-base sm:text-lg tracking-wide">
        {value}
      </div>
    </div>
  );
}
